import script from "./Metadata.vue?vue&type=script&setup=true&lang=js"
export * from "./Metadata.vue?vue&type=script&setup=true&lang=js"

import "./Metadata.vue?vue&type=style&index=0&id=37b736d0&lang=scss&scoped=true"
script.__scopeId = "data-v-37b736d0"

export default script